// extracted by mini-css-extract-plugin
var _1 = "TableExportButton-modulebuttonExport__UGdkx";
export { _1 as "buttonExport" }
